// extracted by mini-css-extract-plugin
export default {"badge":"dayOffArchive_badge__XHBVr","btnsGroup":"dayOffArchive_btnsGroup__rlF5W","status":"dayOffArchive_status__Py+uG"};